import React, { useState, useEffect, useCallback, useRef} from "react";
import { Link, useNavigate } from "react-router-dom";
import NavBarHome from "../NavBarHome";
// import RecentTable from "../recents/RecentTable";

import { Loader } from "../Loader/Loader";
import RecentViews from "../recents/RecentView";
import "./Home.css";
// import DashboardPage from "./DashboardPage";
import { createNewViewWithUniqueID, setUserID } from "../Functions/viewHelpers";
import { auth, db } from "../../../firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { addDoc, collection, updateDoc, doc, getDoc, setDoc } from "firebase/firestore";
import { processUploadedFile } from "../../utils/fileProcessor";
import UploadPasteBlock from "../DropZone/UploadPasteBlock";
import GooglePicker from "../GooglePicker/GooglePicker";
import AgentSelector from "../Agents/AgentSelector";
import DocSelector from "../Docs/DocSelector";
import RecentViewSkeleton from "../recents/RecentViewSkeleton";


// const AnalyticsListener = ({ analytics }) => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     // Log a page_view event whenever the route changes
//     logEvent(analytics, 'page_view', { page_path: location.pathname });
//   }, [location]);

//   return null;
// };

const aiIconSvg = `<span style="margin: 5px;"><svg height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M19.89,9.55A1,1,0,0,0,19,9H14V3a1,1,0,0,0-.69-1,1,1,0,0,0-1.12.36l-8,11a1,1,0,0,0-.08,1A1,1,0,0,0,5,15h5v6a1,1,0,0,0,.69.95A1.12,1.12,0,0,0,11,22a1,1,0,0,0,.81-.41l8-11A1,1,0,0,0,19.89,9.55ZM12,17.92V14a1,1,0,0,0-1-1H7l5-6.92V10a1,1,0,0,0,1,1h4Z"></path></svg></span>`;

onAuthStateChanged(auth, (user) => {
  if (user) {
    setUserID(user.uid);
  } else {
    console.log("No user is signed in.");
  }
});

function Home() {
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessingFile, setIsProcessingFile] = useState(false);
  const [agentMode, setAgentMode] = useState(false);
  const [isGooglePickerOpen, setIsGooglePickerOpen] = useState(false);
  const [oauthToken, setOauthToken] = useState(null);

  const [isAgentModalOpen, setIsAgentModalOpen] = useState(false);
  const [isNewAgentOpen, setIsNewAgentOpen] = useState(false);
  const [currentDoc, setCurrentDoc] = useState(null); // New state for current doc type
  const [availableDocs, setAvailableDocs] = useState([]); // To store all docs from DocsSelector
  const [isDocModalOpen, setIsDocModalOpen] = useState(false);
  const [isNewDocOpen, setIsNewDocOpen] = useState(false);
  const [currentAgent, setCurrentAgent] = useState(null); // New state for current agent
  const [availableAgents, setAvailableAgents] = useState([]); // To store all agents from AgentSelector


  let navigate = useNavigate();

  const agentButtonRef = React.useRef(null);
  const docButtonRef = React.useRef(null);
  const agentSelectorRef = React.useRef(null);
  const docSelectorRef = React.useRef(null);
  const isSequenceRunningRef = React.useRef(null);
  const isInitialLoadRef = React.useRef(null);

  const handleAnalyzeClick = async () => {};
  const handleBuildCanvas = async () => {};
  const loadDataIntoHistory = async () => {};
  const setComponents = () => {};
  const chat = {};

  const handleAgentSelectionFromSelector = (agent) => {
    setCurrentAgent(agent);
  };
  const handleDocSelectionFromSelector = (doc) => {
    setCurrentDoc(doc);
  };


  // Handler for Google Picker data
  const handleSheetData = (blobs) => {
    const files = blobs.map(blob => {
      let fileName = blob.name;
      if (!fileName.toLowerCase().endsWith('.csv')) {
        fileName += '.csv';
      }
      return new File([blob], fileName, { type: blob.type });
    });
    handleFileDrop(files);
  };

  // Enhanced file drop handler
  const handleFileDrop = async (acceptedFiles) => {
    if (acceptedFiles.length === 0) return;

    setIsProcessingFile(true);

    try {
      const currentUser = auth.currentUser;
      if (!currentUser) {
        throw new Error("User not authenticated");
      }

      const firstFile = acceptedFiles[0];
      const firstStructuredData = await processUploadedFile(firstFile);

      // Create new document in Firestore with data from the first file
      const newViewData = {
        createdBy: currentUser.uid,
        title: firstStructuredData.title, // Maybe a generic title
        description: `Generated from ${acceptedFiles.length} files.`,
        contents: [],
        slides: [],
        fileData: {}, // Combined file data?
        createdAt: new Date().toISOString(),
        lastModified: new Date().toISOString(),
      };
      
      // A more generic title
      if (acceptedFiles.length > 1) {
          const baseName = firstFile.name.replace(/\.[^/.]+$/, "");
          newViewData.title = `${baseName}`;
      }


      const newViewRef = await addDoc(collection(db, "views"), newViewData);

      let allContents = [];
      let allSlides = [];
      let allFileData = {};

      for (let i = 0; i < acceptedFiles.length; i++) {
          const file = acceptedFiles[i];
          const structuredData = (i === 0) ? firstStructuredData : await processUploadedFile(file);
          
          allContents.push(...structuredData.contents);
          
          const slideId = `board-${i + 1}`;
          allSlides.push({
              id: slideId,
              components: structuredData.contents.map((comp) => comp.id),
          });

          // Merge fileData
          Object.assign(allFileData, structuredData.fileData);
      }

      // Save all the new structuredData
      await updateDoc(doc(db, "views", newViewRef.id), {
        contents: allContents,
        slides: allSlides,
        fileData: allFileData,
      });

      window.location.href = `/views/${newViewRef.id}${agentMode ? "?agentMode=true" : ""}`;

    } catch (error) {
      console.error("Error processing files:", error);
      alert(`Error processing files: ${error.message}`);
      setIsProcessingFile(false);
    }
  };

  const navigateWithAgentMode = (path) => {
    navigate(`${path}${agentMode ? "?agentMode=true" : ""}`);
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const currentUser = auth.currentUser;
      if (currentUser) {
        const userDocRef = doc(db, "users", currentUser.uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setCurrentAgent(userData.currentAgent);
          setCurrentDoc(userData.currentDoc);
        }
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    const saveUserData = async () => {
      const currentUser = auth.currentUser;
      if (currentUser) {
        const userDocRef = doc(db, "users", currentUser.uid);
        await setDoc(userDocRef, {
          currentAgent,
          currentDoc,
        }, { merge: true });
      }
    };
    if (currentAgent || currentDoc) {
      saveUserData();
    }
  }, [currentAgent, currentDoc]);
  
    
  
  const handleAgentModalToggle = (toggle) => {
    // Check if an explicit boolean value was passed as the argument
    if (typeof toggle === "boolean") {
      // If true or false was passed, set the state directly
      setIsAgentModalOpen(toggle);
      // If explicitly setting to false (closing), also close the new agent form
      if (!toggle) {
        setIsNewAgentOpen(false);
      }
    } else {
      // If no argument (or a non-boolean) was passed, toggle the current state
      setIsAgentModalOpen((prevState) => {
        const newState = !prevState; // Calculate the new state (opposite of previous)
        // If the toggle results in the modal being closed (newState is false)
        if (!newState) {
          setIsNewAgentOpen(false); // Also close the new agent form
        }
        return newState; // Return the calculated new state
      });
    }
    // The line below was commented out, keep it that way unless you specifically need it
    // setIsDrawerOpen(!isDrawerOpen);
  };

  const handleNewAgentToggle = (toggle) => {
    setIsNewAgentOpen(toggle);
    setIsAgentModalOpen(true);

    if (toggle) {
      setIsAgentModalOpen(true);
    }
  };

  const handleDocModalToggle = (toggle) => {
    // Check if an explicit boolean value was passed as the argument
    if (typeof toggle === "boolean") {
      // If true or false was passed, set the state directly
      setIsDocModalOpen(toggle);
      // If explicitly setting to false (closing), also close the new agent form
      if (!toggle) {
        setIsNewDocOpen(false);
      }
    } else {
      // If no argument (or a non-boolean) was passed, toggle the current state
      setIsDocModalOpen((prevState) => {
        const newState = !prevState; // Calculate the new state (opposite of previous)
        // If the toggle results in the modal being closed (newState is false)
        if (!newState) {
          setIsNewDocOpen(false); // Also close the new agent form
        }
        return newState; // Return the calculated new state
      });
    }
    // The line below was commented out, keep it that way unless you specifically need it
    // setIsDrawerOpen(!isDrawerOpen);
  };

  const handleNewDocToggle = (toggle) => {
    setIsNewDocOpen(toggle);
    setIsDocModalOpen(true);

    if (toggle) {
      setIsDocModalOpen(true);
    }
  };

  const handleAgentToggle = () => {
    setAgentMode(!agentMode);
    setIsAgentModalOpen(false);
    setIsDocModalOpen(false);
  }
  return (
    <div style={{ position: "relative" }}>
      <NavBarHome title="Home" />
      {isLoading && <Loader isLoading={isLoading} />}
      {isProcessingFile && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            height: "100vh",
            width: "100%",
            backgroundColor: "rgba(20, 20, 20, 0.95)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            // color: "white",
            fontSize: "18px",
          }}
        >
          
          <div style={{ textAlign: "center", width: "100%", maxWidth: "720px", minWidth: "360px" }}>
            <h1 style={{ color: "var(--Grey1)"}}>Building your new view</h1>
            <div style={{ marginTop: "10px", marginBottom: "36px",fontSize: "14px" }}>Processing data...</div>
            <RecentViewSkeleton count={3}  />
          </div>
        </div>
      )}
      {/* <div className="home">
        <div className="quickstart">
          <h3>Quick Start</h3>
          <p>
            Enter any combination of data, measures, and charting style for us
            to get you started.
          </p>
        </div>
        <div className="suggestions">
          <h4>I would like to see:</h4>
          <div className="btns">
            <button className="homeBTN">Transportation in US by month</button>
            <button className="homeBTN">
              What are new trends in retail consumer behavior
            </button>
            <button className="homeBTN">
              Temperature vs rainfall in your area
            </button>
            <button className="homeBTN">Annual healthcare cost averages</button>
          </div>
        </div> */}


      <div className="cards-wrapper">
        {/* My Recent Views */}
        <div className="cards-group">
          <div className="card-header">
            <h3>My recent views</h3>{" "}
            <Link to="/views" className="card-header-link">
              see all ➜
            </Link>
          </div>
          <RecentViews isMenu={false} showActions={false} limit={5} isLoading={isLoading} setIsLoading={setIsLoading} />
        </div>

        {/* Start a new view */}
        <div className="cards-group">
          <div className="start-new-view-header">
            <h3>Start a new view</h3>
            <div
              className={`agent-mode-toggle ${agentMode ? "active" : ""}`}
              onClick={() => handleAgentToggle()}
            >
              <div
                className="agent-mode-icon"
                dangerouslySetInnerHTML={{ __html: aiIconSvg }}
              />
              <span className="agent-mode-text">Agent Mode</span>
            </div>
          </div>
          
          <div
            style={{
              display: "grid",
              gridTemplateRows: agentMode ? "1fr" : "0fr",
              transition: "grid-template-rows 0.3s ease-out",
              position: "relative",
              right: "-8px",
            }}
          >
            <div style={{ overflow: "hidden"}}>
              <div style={{ display: "flex", justifyContent: "flex-end", flexDirection: "row", alignItems: "center", marginBottom: "8px", width: "100%" }}>
              {/* AGENT */}
              <button
                type="button"
                ref={agentButtonRef}
                className={`resFooterButton ${isAgentModalOpen ? "active" : ""}`}
                style={{
                  position: "relative",
                  left: "-8px",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "left",
                  // minWidth: "150px",
                  maxWidth: "200px",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  // paddingRight: "10px",
                  marginRight: "0px",
                  textWrap: "nowrap",
                }}
                onClick={handleAgentModalToggle}
              >
                <div style={{ top: "-2px", position: "relative" }}>
                  <span style={{ fontSize: "10px", letterSpacing: "1px", opacity: "0.7" }}>ANALYZE</span>
                  <br></br>
                  {currentAgent?.name || "Select Agent"}
                </div>

                <div>
                  {isAgentModalOpen ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-10 0 24 24" width={26} height={20} id="angle-up">
                      <path
                        fill="var(--Grey7)"
                        d="M17,13.41,12.71,9.17a1,1,0,0,0-1.42,0L7.05,13.41a1,1,0,0,0,0,1.42,1,1,0,0,0,1.41,0L12,11.29l3.54,3.54a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29A1,1,0,0,0,17,13.41Z"
                      ></path>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-10 0 24 24" width={26} height={20} id="angle-down">
                      <path fill="var(--Grey7)" d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
                    </svg>
                  )}
                </div>
              </button>

              {/* DOCUMENT */}
              <button
                type="button"
                ref={docButtonRef}
                className={`resFooterButton ${isDocModalOpen ? "active" : ""}`}
                style={{
                  position: "relative",
                  left: "-8px",
                  paddingTop: "-8px",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "left",
                  // minWidth: "150px",
                  maxWidth: "200px",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  // paddingRight: "10px",
                  marginRight: "0px",
                  textWrap: "nowrap",
                }}
                onClick={handleDocModalToggle}
              >
                <div style={{ top: "-2px", position: "relative" }}>
                  <span style={{ fontSize: "10px", letterSpacing: "1px", opacity: "0.7" }}>BUILD</span>
                  <br></br>
                  {currentDoc?.name || "Select document"}
                </div>

                <div>
                  {isDocModalOpen ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-10 0 24 24" width={26} height={20} id="angle-up">
                      <path
                        fill="var(--Grey7)"
                        d="M17,13.41,12.71,9.17a1,1,0,0,0-1.42,0L7.05,13.41a1,1,0,0,0,0,1.42,1,1,0,0,0,1.41,0L12,11.29l3.54,3.54a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29A1,1,0,0,0,17,13.41Z"
                      ></path>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-10 0 24 24" width={26} height={20} id="angle-down">
                      <path fill="var(--Grey7)" d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
                    </svg>
                  )}
                </div>
              </button>
                </div>
                
              <br />
              </div>
              </div>

              <div style={{ position: "relative", zIndex: 2000 }}>
                <div ref={agentSelectorRef} style={{ position: "absolute", top: "-38px", right: "-5px", paddingRight: "5px", float: "right" }}>
                  <AgentSelector // Ensure it takes full width
                    closeModal={() => handleAgentModalToggle(false)} // Pass function to explicitly close the modal
                    isOpen={isAgentModalOpen} // Pass the state to control visibility
                    onClose={() => handleAgentModalToggle(false)} // Pass the close handler
                    handleNewAgentToggle={handleNewAgentToggle} // Pass the handler for the "Create New Agent" button
                    isNewAgentOpen={isNewAgentOpen} // Pass the state for the new agent form
                    setCurrentAgent={handleAgentSelectionFromSelector} // Use the stable handler
                    setAvailableAgentsList={setAvailableAgents} // Pass setter for AgentSelector to populate
                  />
                </div>

                <div ref={docSelectorRef} style={{ position: "absolute", top: "-38px", right: "-5px", paddingRight: "5px", float: "right" }}>
                  <DocSelector // Ensure it takes full width
                    closeModal={() => handleDocModalToggle(false)} // Pass function to explicitly close the modal
                    isOpen={isDocModalOpen} // Pass the state to control visibility
                    onClose={() => handleDocModalToggle(false)} // Pass the close handler
                    handleNewDocToggle={handleNewDocToggle} // Pass the handler for the "Create New Doc" button
                    isNewDocOpen={isNewDocOpen} // Pass the state for the new doc form
                    setCurrentDoc={handleDocSelectionFromSelector}
                    setAvailableDocsList={setAvailableDocs}
                  />
                </div>
          </div>

          <div className="cards"> 

          <h4 className="cards-group-header">Connect data</h4>
          
                     <div className="btns">

          <button className="homeBTN" style={{ paddingLeft: '12px', paddingRight: '12px' }}>
                <UploadPasteBlock
                onFileDrop={handleFileDrop}
                // onPaste={(pastedData) => {
                //   // Convert the pasted data to structured data if needed
                // }}
                isProcessingFile={isProcessingFile}
            />
           </button>

            <button
                className="homeBTN"
                onClick={() => setIsGooglePickerOpen(true)}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', justifyContent: 'center' }}>
                <img src="../../icons/Google_Sheets_logo.svg" alt="Google Sheets" style={{ borderRadius: '0px', width: '48px', height: '64px', marginBottom: '24px' }} />
                <img src="../../icons/google-tile.svg" alt="Google Sheets" style={{ width: '64px', height: '64px', marginBottom: '16px' }} />
                
                </div>
                Connect to Google Sheets

              </button>

            {/* <button className="homeBTN" style={{ paddingLeft: '12px', paddingRight: '12px' }}>
                <UploadPasteBlock
                onFileDrop={handleFileDrop}
                // onPaste={(pastedData) => {
                //   // Convert the pasted data to structured data if needed
                // }}
                isProcessingFile={isProcessingFile}
              />
            </button> */}

          </div>

          </div>
          


        </div>
      </div>
      <GooglePicker
        isRequested={isGooglePickerOpen}
        onCSVBlobsCreated={handleSheetData}
        onClose={() => setIsGooglePickerOpen(false)}
        oauthToken={oauthToken}
        setOauthToken={setOauthToken}
      />
    </div>
  );
}

export default Home;
